import React from "react";
import {
    Box,
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography
} from "@mui/material";

export interface CreateForecastDialogProps {
    open: boolean;
    isCreating: boolean;
    copyCurrentForecastData: boolean;
    canCopyCurrentForecastData: boolean;
    onCopyCurrentForecastDataChange: (value: boolean) => void;
    onClose: () => void;
    onSubmit: () => void;
}

const CreateForecastDialog: React.FC<CreateForecastDialogProps> = ({
    open,
    isCreating,
    copyCurrentForecastData,
    canCopyCurrentForecastData,
    onCopyCurrentForecastDataChange,
    onClose,
    onSubmit
}) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            disableEscapeKeyDown={isCreating}
        >
            <DialogTitle>Create Forecast</DialogTitle>
            <DialogContent>
                {isCreating ? (
                    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2, py: 3 }}>
                        <CircularProgress />
                        <Typography>
                            Creating forecast{copyCurrentForecastData ? " and copying data" : ""}...
                        </Typography>
                    </Box>
                ) : (
                    <>
                        <p>
                            Are you sure you wish to create the next forecast year?
                        </p>
                        {canCopyCurrentForecastData && (
                            <Box mt={2}>
                                <label>
                                    <input
                                        type="checkbox"
                                        checked={copyCurrentForecastData}
                                        onChange={(e) => onCopyCurrentForecastDataChange(e.target.checked)}
                                        disabled={isCreating}
                                    />
                                    {" Copy current customer base forecast data from current forecast year"}
                                </label>
                            </Box>
                        )}
                    </>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="secondary" disabled={isCreating}>
                    Cancel
                </Button>
                <Button onClick={onSubmit} color="primary" disabled={isCreating}>
                    {isCreating ? "Creating..." : "Create"}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default CreateForecastDialog;

